import React from "react";

interface IImeiContext {
  imei: string | undefined,
  updateImei: (imei: string) => void,
}

const ImeiContext = React.createContext<IImeiContext>({
  imei: undefined,
  updateImei: () => {},
});
export default ImeiContext;
